import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceTableComponent } from './components/invoice-table.component';
import { InvoiceClientService } from '@services/api/invoice/invoice-client.service';
import { FileDownloadService } from '@services/util/file-download.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-invoicing',
  imports: [InvoiceTableComponent, TranslateModule],
  templateUrl: './invoicing.component.html'
})
export class InvoicingComponent {
  constructor(
    private readonly router: Router,
    private readonly invoiceClientService: InvoiceClientService,
    private readonly fileDownloadService: FileDownloadService
  ) {}

  onViewInvoiceDetails(invoiceId: number): void {
    // Navigate to invoice preview in same tab
    this.router.navigate(['/invoices', invoiceId, 'preview']);
  }

  onEditInvoiceDetails(invoiceId: number): void {
    // Navigate to invoice details page
    this.router.navigate(['/invoices', invoiceId]);
  }

  onDownloadInvoicePdf(invoiceId: number): void {
    const filename = `invoice_${invoiceId}.pdf`;
    
    this.fileDownloadService
      .handleBlobDownload(
        this.invoiceClientService.downloadPdf(invoiceId),
        filename
      )
      .pipe(
        catchError(error => {
          console.error('Failed to download invoice PDF:', error);
          // TODO: Add user-friendly error notification here
          return of(false);
        })
      )
      .subscribe({
        next: (success) => {
          if (success) {
            console.log(`PDF downloaded successfully: ${filename}`);
            // TODO: Add success notification here
          }
        },
        error: (error) => {
          console.error('Download error:', error);
          // TODO: Add error notification here
        }
      });
  }
}
